import type { Entity } from '@backstage/catalog-model';

export const CICD_PROMOTER_ANNOTATIONS = {
  ENABLED: 'cicd-promoter.internal/enabled',
} as const;

export function isCicdPromoterAvailable(entity: Entity): boolean {
  return (
    entity.metadata.annotations?.[CICD_PROMOTER_ANNOTATIONS.ENABLED] === 'true'
  );
}

const GITHUB_URL_PATTERN = /github\.com\/([^/?#]+)\/([^/?#]+?)(?:\.git)?(?:[/?#].*)?$/;

export interface GithubOwnerRepo {
  owner: string;
  repo: string;
}

/**
 * Resolves an entity's GitHub owner/repo from whichever annotation or link
 * it happens to carry. The two known cicd-promoter adopters expose this
 * differently — one sets `github.com/project-slug`, the other sets neither
 * `project-slug` nor `backstage.io/source-location`, only a `metadata.links`
 * entry — so all three sources are tried in order.
 */
export function getGithubOwnerRepo(entity: Entity): GithubOwnerRepo | undefined {
  const projectSlug = entity.metadata.annotations?.['github.com/project-slug'];
  if (projectSlug) {
    const [owner, repo] = projectSlug.split('/');
    if (owner && repo) return { owner, repo };
  }

  const sourceLocation = entity.metadata.annotations?.['backstage.io/source-location'];
  if (sourceLocation) {
    const match = sourceLocation.match(GITHUB_URL_PATTERN);
    if (match) return { owner: match[1], repo: match[2] };
  }

  const links = entity.metadata.links ?? [];
  for (const link of links) {
    const match = link.url?.match(GITHUB_URL_PATTERN);
    if (match) return { owner: match[1], repo: match[2] };
  }

  return undefined;
}
